interface LegendItem {
  cor: string;
  label: string;
  descricao: string;
}

const legendItems: LegendItem[] = [
  { cor: "#1B6E4F", label: "Bom / Risco Baixo", descricao: "Árvore saudável, sem intervenção necessária" },
  { cor: "#FBC02D", label: "Risco Médio", descricao: "Atenção moderada, monitorar periodicamente" },
  { cor: "#F57C00", label: "Risco Alto", descricao: "Intervenção recomendada, vistoria urgente" },
  { cor: "#D32F2F", label: "Risco Crítico", descricao: "Perigo iminente, ação emergencial necessária" },
  { cor: "#90A4AE", label: "Morto / Inativo", descricao: "Indivíduo morto ou removido" },
  { cor: "#64B5F6", label: "Área Verde / UC", descricao: "Área verde pública ou Unidade de Conservação" },
  { cor: "#1B6E4F", label: "Projeto CTA", descricao: "Área de abrangência de projeto ativo" },
];

export default function MapLegend({ collapsed, onToggle }: { collapsed: boolean; onToggle: () => void }) {
  return (
    <div className={`bg-white/95 backdrop-blur-sm border border-background-200/70 rounded-card shadow-sm transition-all ${collapsed ? "w-10" : "w-52"}`}>
      <div className="flex items-center justify-between px-2.5 py-2">
        {!collapsed && <span className="text-[11px] font-semibold text-foreground-800 font-heading whitespace-nowrap">Legenda</span>}
        <button
          onClick={onToggle}
          className="w-6 h-6 flex items-center justify-center rounded-md hover:bg-background-100 transition-colors shrink-0"
          title={collapsed ? "Expandir legenda" : "Recolher legenda"}
        >
          <i className={`text-foreground-500 text-sm ${collapsed ? "ri-arrow-left-s-line" : "ri-arrow-right-s-line"}`}></i>
        </button>
      </div>

      {!collapsed && (
        <div className="px-2.5 pb-2.5 space-y-2">
          {legendItems.map((item) => (
            <div key={item.label} className="flex items-start gap-2">
              <div
                className="w-3.5 h-3.5 rounded-full mt-0.5 shrink-0"
                style={{ backgroundColor: item.cor }}
                role="img"
                aria-label={item.label}
              ></div>
              <div className="min-w-0">
                <p className="text-[11px] font-medium text-foreground-800 leading-tight whitespace-nowrap">{item.label}</p>
                <p className="text-[10px] text-foreground-500 leading-tight">{item.descricao}</p>
              </div>
            </div>
          ))}

          {/* Marker shapes */}
          <div className="pt-1.5 border-t border-background-200/70">
            <p className="text-[10px] text-foreground-500 mb-1">Marcadores</p>
            <div className="flex items-center gap-3 text-[10px] text-foreground-600">
              <span className="flex items-center gap-1 whitespace-nowrap">
                <span className="w-2.5 h-2.5 rounded-full bg-primary-500 inline-block"></span> Árvore
              </span>
              <span className="flex items-center gap-1 whitespace-nowrap">
                <span className="w-2.5 h-2.5 rounded-sm bg-accent-400 inline-block"></span> Palmeira
              </span>
              <span className="flex items-center gap-1 whitespace-nowrap">
                <span className="w-2 h-2 border-2 border-primary-500 inline-block"></span> Muda
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}